@if(eventLinkOverride() === null) {
  <ng-container *ngTemplateOutlet="routerLinkCard"/>
}
@else {
  <ng-container *ngTemplateOutlet="hrefCard"/>
}

<ng-template #hrefCard>
  <a [href]="eventLinkOverride()">
    <ng-container *ngTemplateOutlet="card"/>
  </a>
</ng-template>

<ng-template #routerLinkCard>
  <a [routerLink]="eventWebRoute()">
    <ng-container *ngTemplateOutlet="card"/>
  </a>
</ng-template>

<ng-template #card>
  <div class="flex flex-row items-center gap-x-4 hover:bg-gray-100 rounded-md">
    <img [src]="event().coverImage" class="flex-initial h-20 aspect-square rounded-md object-cover">
    <div class="flex-1">
      <div class="flex flex-col items-start">
        <div>
          <h1 class="line-clamp-2 text-sm text-default-light font-semibold tracking-tightest">{{name()}}</h1>
        </div>

        <div>
          <app-start-date [startDate]="event().startDate" [eventDateFormat]="event().eventDateFormat" [timezone]="timezone()"></app-start-date>
        </div>

        <div>
          <app-location-info [locationInfo]="event().locationInfo"></app-location-info>
        </div>
      </div>
    </div>
  </div>
</ng-template>
